import type { UnionToTuple } from "type-fest";
import { z } from "zod";

import { zOutSchema } from "./common";

import { ListParams, Pagination } from "~/shared/zod";

const zOut = Pagination.Page2.zSchema(
  zOutSchema,
  z.object({
    totalItemsRead: z.number().int().nonnegative(),
  }),
);
type Out = z.infer<typeof zOut>;

type Key = keyof Out["items"][number];

const EXCLUDED_KEYS = ["action", "entity"] as const satisfies Key[];

const zFieldsToSortBy = z.enum(
  Object.values(zOut.shape.items.element.keyof().Enum).filter(
    (value) => !(EXCLUDED_KEYS as string[]).includes(value),
  ) as UnionToTuple<Exclude<Key, (typeof EXCLUDED_KEYS)[number]>>,
);
const FieldsToSortBy = zFieldsToSortBy.Enum;
type FieldsToSortBy = z.infer<typeof zFieldsToSortBy>;

const zIn = ListParams.zSchema(zFieldsToSortBy);
type In = z.infer<typeof zIn>;

export { FieldsToSortBy, zFieldsToSortBy, zIn, zOut };
export type { In, Out };
